"use client";
import Footer from "@/components/shared/Footer";
import Header from "@/components/shared/Header";
import Image from "next/image";
import ReadyForSuccess from "@/components/HomeComponents/ReadyForSuccess";
import FrequentlyQuestions from "@/components/HomeComponents/FrequentlyQuestions";
import AdvantagesPlatform from "@/components/HomeComponents/AdvantagesPlatform";
import AcademyInstructors from "@/components/HomeComponents/AcademyInstructors";
import AchieveYourGoals from "@/components/HomeComponents/AchieveYourGoals";
import PopularBooks from "@/components/HomeComponents/PopularBooks";
import LatestExams from "@/components/HomeComponents/LatestExams";
import LatestCourses from "@/components/HomeComponents/LatestCourses";
import Subjects from "@/components/HomeComponents/Subjects";
import TelegramLogin from "@/components/HomeComponents/TelegramLogin";
import HeroHome from "@/components/HomeComponents/HeroHome";
import AdGalleryModal from "@/components/HomeComponents/AdGalleryModal";
import SocialMedia from "@/components/shared/socialMedia/SocialMedia";
import SearchSection from "@/components/HomeComponents/SearchSection/SearchSection";
import NewYearBooking from "@/components/HomeComponents/NewYearBooking";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import { useEffect, useState } from "react";
import USER, { SelectHome } from "@/redux/User";
import TelegramChannel from "@/components/HomeComponents/TelegramChannel";
// import TestChat from "@/app/test-chat";
// import "@n8n/chat/style.css";
// import { createChat } from "@n8n/chat";

export default function Home() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const dispatch = useAppDispatch();
  const home = useAppSelector(SelectHome);
  const [loading, setLoading] = useState(true);
  const [showAdGallery, setShowAdGallery] = useState(true);

  // Initialize chat on component mount
  // useEffect(() => {
  //   createChat({
  //     webhookUrl:
  //       "http://localhost:5678/webhook/e5616171-e3b5-4c39-81d4-67409f9fa60a/chat", // 🔴 غيّر الدومين ده للن8n بتاعك
  //     webhookConfig: {
  //       method: "POST",
  //       headers: {},
  //     },
  //     target: "#n8n-chat", // ده لازم يكون موجود في الـ DOM
  //     mode: "window",
  //     chatInputKey: "chatInput",
  //     chatSessionKey: "sessionId",
  //     loadPreviousSession: true,
  //     metadata: {},
  //     showWelcomeScreen: false,
  //     defaultLanguage: "en",
  //     initialMessages: [
  //       "أهلا بيك في بوت إديوفاليو - Eduvalu Bot! 😊",
  //       "اسمي Edu، وأنا هنا لمساعدتك في رحلتك التعليمية. 📚",
  //     ],
  //     enableStreaming: false,
  //   });
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(USER.thunks.doGetHome({}));
      setLoading(false);
    };
    fetchData();
  }, []);

  // Always show ad on component mount
  useEffect(() => {
    setShowAdGallery(true);
  }, []);

  const closeAdGallery = () => {
    setShowAdGallery(false);
  };

  const adImages = home?.ads ?? [];

  return (
    <div className="bg-[#202225] text-white min-h-screen">
      {/* Advertisement Gallery Modal */}
      {showAdGallery && adImages.length >= 1 && (
        <AdGalleryModal
          loading={loading}
          images={adImages}
          onClose={closeAdGallery}
        />
      )}

      {/* <TestChat /> */}

      <Header />

      {/* Hero Section */}
      <section className="container relative flex flex-col items-center justify-center py-16 px-4 md:px-0">
        <HeroHome home={home} />
      </section>

      {/* Telegram Channel Section */}
      <section className="container mx-auto py-12 px-4">
        <TelegramChannel />
      </section>

      {/* Telegram Login Section */}
      <section className="container mx-auto py-12 px-4">
        <TelegramLogin />
      </section>

      {/* Instructors Section */}
      <section className="container mx-auto py-12 px-4">
        <AcademyInstructors
          loading={loading}
          teachers={home?.teachers}
          full={true}
        />
      </section>

      {/* Achievements Section */}
      <section className="container mx-auto py-12 px-4">
        <AchieveYourGoals loading={loading} achievements={home?.achievements} />
      </section>

      {/* New Year Booking Section */}
      <section className="container mx-auto py-12 px-4">
        <NewYearBooking />
      </section>

      {/* Latest Courses Section */}
      <section className="container mx-auto py-12 px-4">
        <LatestCourses loading={loading} courses={home?.courses} />
      </section>

      {/* Latest Exams Section */}
      <section className="container mx-auto py-12 px-4">
        <LatestExams loading={loading} fullExams={home?.full_exams} />
      </section>

      {/* Popular Books Section */}
      {/* <section className="container mx-auto py-12 px-4">
        <PopularBooks loading={loading} books={home?.books} />
      </section> */}

      {/* Subjects Section */}
      <section className="container mx-auto py-12 px-4">
        <Subjects loading={loading} subjects={home?.subjects} />
      </section>

      {/* Features/Advantages Section */}
      <section className="container mx-auto py-12 px-4">
        <AdvantagesPlatform />
      </section>

      {/* FAQ Section */}
      <section className="container mx-auto py-12 px-4">
        <FrequentlyQuestions />
      </section>

      {/* Call to Action Section */}
      <section className="container mx-auto py-12 px-4">
        <ReadyForSuccess />
      </section>

      <Footer />
      <SocialMedia />

      {/* ✅ لازم يكون موجود علشان الشات يترندر فيه */}
      <div id="n8n-chat"></div>
    </div>
  );
}
